/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Subscription_Token_RejectedInputs */

const en_byoa_subscription_token_rejected = /** @type {(inputs: Byoa_Subscription_Token_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This looks like a subscription login, not an API key. Bystep does not store subscription logins; use an API key from your provider's console or run the agent on your own computer.`)
};

const id_byoa_subscription_token_rejected = /** @type {(inputs: Byoa_Subscription_Token_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini terlihat seperti kode login langganan, bukan kunci API. Bystep tidak menyimpan kode login langganan; pakai kunci API dari konsol penyedia atau jalankan agen di komputer kamu.`)
};

/**
* | output |
* | --- |
* | "This looks like a subscription login, not an API key. Bystep does not store subscription logins; use an API key from your provider's console or run the agent..." |
*
* @param {Byoa_Subscription_Token_RejectedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_subscription_token_rejected = /** @type {((inputs?: Byoa_Subscription_Token_RejectedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Subscription_Token_RejectedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_subscription_token_rejected(inputs)
	return en_byoa_subscription_token_rejected(inputs)
});